import React, { useLayoutEffect, useRef, useState } from 'react';
import { OpenHouseEntry } from '../../../interfaces/interfaces';
import { OpenHouseListItem } from './OpenHouseListItem';
import { useRecoilValue } from 'recoil';
import * as AppState from '../../../AppState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';
import { Button } from '@capcenter/shared';
import './OpenHousesList.scss';

export const OpenHousesList = (props: { OpenHouses: OpenHouseEntry[]; address: string }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [SeeAll, setSeeAll] = useState(false);
  const userOnMobile = useRecoilValue(AppState.gsIsMobile);
  const [contentHeight, setContentHeight] = useState<number>(0);
  const [closedHeight, setClosedHeight] = useState<number>(0);
  const [isOpen, setIsOpen] = useState(false);

  const openHouses = props.OpenHouses.filter(openHouse => new Date(openHouse.OpenHouseEndTime) > new Date()).sort(
    (a, b) => new Date(a.OpenHouseStartTime).getTime() - new Date(b.OpenHouseStartTime).getTime(),
  );

  useLayoutEffect(() => {
    const refHeight = ref && ref.current && ref.current.getBoundingClientRect().height;
    setContentHeight(refHeight ?? 0);
    setClosedHeight(openHouses.length > 1 ? 75 : 0);

    const detailsWindow = document.getElementById('propertydetails');
    const detailsTop = document.getElementById('propertyDetailsFull')!.getBoundingClientRect().top;
    if (detailsTop < 0) {
      detailsWindow?.scrollBy(0, detailsTop - 75);
    }
  }, [ref]);

  const expansionStyle = {
    height: isOpen ? contentHeight : closedHeight,
    overflow: 'hidden',
    minHeight: openHouses.length > 1 ? 75 : 0,
  };

  if (!openHouses.length) {
    return <></>;
  }

  if (userOnMobile) {
    return (
      <section>
        <div
          className="w-100 px-5 text-center mt-3 expansion-content__content-wrapper"
          style={{ color: 'rgb(12, 44, 72)' }}
        >
          <div className="px-5 py-1">
            <h2 className="fs-3" style={{ fontWeight: 'bold' }}>
              Open House Dates
            </h2>
          </div>

          <div className={'row justify-content-center '}>
            <OpenHouseListItem
              OpenHouse={openHouses[0]}
              address={props.address}
              key={openHouses[0] && openHouses[0].Id}
              hidden={false}
            />
          </div>
          <div className="expansion-content" aria-expanded={isOpen} style={expansionStyle}>
            {openHouses.length > 1 && (
              <div
                className={classNames(
                  !isOpen && 'open-Houses-List__fade-overlay--active',
                  'open-Houses-List__fade-overlay',
                )}
              />
            )}
            <div className={'row justify-content-center '} ref={ref}>
              {openHouses.map((openHouse, index) => {
                return (
                  index >= 1 && (
                    <OpenHouseListItem
                      OpenHouse={openHouse}
                      address={props.address}
                      key={openHouse.Id}
                      hidden={false}
                    />
                  )
                );
              })}
            </div>
          </div>
        </div>
        {openHouses.length > 1 && (
          <div className="w-100 text-center pt-1">
            <Button
              bold
              fullWidth
              resetText
              label={
                isOpen ? (
                  <span>
                    See Less <FontAwesomeIcon icon={faChevronUp} />
                  </span>
                ) : (
                  <span>
                    See More <FontAwesomeIcon icon={faChevronDown} />
                  </span>
                )
              }
              color="secondary"
              variant="flat"
              className={classNames('w-100', 'col-12 col-sm-8 col-lg-3')}
              onClick={() => setIsOpen(!isOpen)}
            />
          </div>
        )}
      </section>
    );
  }

  return (
    <section className="shadow border-radius mt-4 cc-bg--white-100 w-100 pt-2" style={{ color: 'rgb(12, 44, 72)' }}>
      <div className="w-100 px-4 text-center">
        <div className="py-1">
          <h2 className="fs-3" style={{ fontWeight: 'bold' }}>
            Open House Dates
          </h2>
        </div>
        <div className={'row justify-content-center '}>
          <OpenHouseListItem
            OpenHouse={openHouses[0]}
            address={props.address}
            key={openHouses[0] && openHouses[0].Id}
            hidden={false}
          />
        </div>
        <div className="expansion-content" aria-expanded={isOpen} style={expansionStyle}>
          {openHouses.length > 1 && (
            <div
              className={classNames(
                !isOpen && 'open-Houses-List__fade-overlay--active',
                'open-Houses-List__fade-overlay',
              )}
            />
          )}
          <div className={'row justify-content-center '} ref={ref}>
            {openHouses.map((openHouse, index) => {
              return (
                index >= 1 && (
                  <OpenHouseListItem OpenHouse={openHouse} address={props.address} key={openHouse.Id} hidden={false} />
                )
              );
            })}
          </div>
        </div>
      </div>
      {openHouses.length > 1 && (
        <div className="w-100 text-center pt-1">
          <Button
            bold
            fullWidth
            resetText
            label={
              isOpen ? (
                <span>
                  See Less <FontAwesomeIcon icon={faChevronUp} />
                </span>
              ) : (
                <span>
                  See More <FontAwesomeIcon icon={faChevronDown} />
                </span>
              )
            }
            color="secondary"
            variant="flat"
            className={classNames('w-100', 'col-12 col-sm-8 col-lg-3')}
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>
      )}
    </section>
  );
};
